module.exports = __webpack_public_path__ + "static/img/zhong12.f7d8c63.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhong12.png
// module id = mUk/
// module chunks = 16